import { Ref, computed } from 'vue';

const useCommonGetters = <T>(state: Ref<T>) => {
  const get = (fieldName: keyof T) => computed(() => state.value[fieldName]);

  return {
    get,
  };
};

export default useCommonGetters;
